{
  "title": "Attachments",
  "add": "Add files",
  "thisRecord": "this record",
  "rules": "PDF, images (JPG, PNG, WebP), Word, Excel, CSV or text, up to {{limit}} each.",
  "dropHint": "Or drop files here.",
  "dropHere": "Drop to attach to {{record}}",
  "loadFailed": "The attachments couldn't be loaded.",
  "retry": "Try again",
  "uploadedBySystem": "System",
  "camera": {
    "take": "Take a photo",
    "empty": "No photos yet. Take one of the work, or add a file."
  },
  "empty": {
    "none": "No attachments.",
    "invite": {
      "document": "Add delivery notes, contracts or photos.",
      "purchase": "Add the supplier's invoice or delivery note.",
      "expense": "Add the receipt or the supplier's bill.",
      "voucher": "Add the bank slip, cheque copy or other proof.",
      "party": "Add contracts, trade licences or ID copies.",
      "product": "Add spec sheets, certificates or photos.",
      "photo": "Add photos of what you found."
    }
  },
  "size": {
    "bytes": "{{size}} B",
    "kb": "{{size}} KB",
    "mb": "{{size}} MB"
  },
  "actions": {
    "download": "Download {{name}}",
    "open": "Open {{name}} in a new tab",
    "remove": "Remove {{name}}"
  },
  "upload": {
    "waiting": "Waiting · {{size}}",
    "sending": "Uploading · {{size}}",
    "sendingPercent": "Uploading · {{percent}}% of {{size}}",
    "progressLabel": "Uploading {{name}}",
    "retry": "Try again",
    "cancel": "Stop uploading {{name}}",
    "dismiss": "Dismiss {{name}}"
  },
  "remove": {
    "title": "Remove {{name}}?",
    "body": "It will no longer be attached to {{record}}. To have it back, upload it again.",
    "confirm": "Remove"
  },
  "toast": {
    "removed": "{{name}} removed"
  },
  "announce": {
    "uploading_one": "Uploading 1 file.",
    "uploading_other": "Uploading {{count}} files.",
    "attached": "{{name}} attached.",
    "removed": "{{name}} removed."
  },
  "errors": {
    "FILE_TOO_LARGE": "Larger than {{limit}}. Compress it or split it into smaller files.",
    "UNSUPPORTED_FILE_TYPE": "This type of file can't be attached. Use PDF, an image, Word, Excel, CSV or text.",
    "contentMismatch": "Its content isn't a real {{type}} file. Save it again as {{type}}, or choose another file.",
    "FILE_REQUIRED": "The file is empty. Choose it again.",
    "IMAGE_TOO_LARGE": "The image is larger than {{max}} × {{max}} pixels. Resize it and upload it again.",
    "FILE_UNAVAILABLE": "This file is held by the virus check and can't be opened. Try again later, or ask an administrator.",
    "notFound": "This file or record is no longer here. Reload the page to see what is attached now.",
    "logoType": "The logo must be a PNG, JPEG or WebP image.",
    "logoTooLarge": "The logo is larger than {{limit}}. Save it smaller and upload it again.",
    "signatureType": "The signature must be a PNG, JPEG or WebP image.",
    "signatureTooLarge": "The signature image is larger than {{limit}}. Save it smaller and upload it again.",
    "stampType": "The stamp must be a PNG, JPEG or WebP image.",
    "stampTooLarge": "The stamp image is larger than {{limit}}. Save it smaller and upload it again."
  },
  "pending": {
    "label": "Attachments",
    "add": "Add files",
    "willAttach_one": "1 file will be attached when you save.",
    "willAttach_other": "{{count}} files will be attached when you save.",
    "summary_one": "1 file",
    "summary_other": "{{count}} files",
    "remove": "Don't attach {{name}}",
    "toast": {
      "title": "Attaching files",
      "sending": "Attaching {{current}} of {{count}} · {{percent}}%",
      "attached_one": "1 file attached.",
      "attached_other": "{{count}} files attached.",
      "failed_one": "1 file couldn't be attached: {{names}}. Add it again from the record.",
      "failed_other": "{{count}} files couldn't be attached: {{names}}. Add them again from the record."
    }
  },
  "paperclip_one": "1 attachment",
  "paperclip_other": "{{count}} attachments",
  "logo": {
    "title": "Company logo",
    "body": "Printed at the head of invoices, quotations, credit notes, statements and the shared invoice page.",
    "rules": "PNG, JPEG or WebP, up to {{limit}} and {{max}} × {{max}} pixels. A wide logo on a clear background prints best.",
    "none": "No logo yet. Documents print the company name alone.",
    "preview": "As printed",
    "upload": "Upload logo",
    "replace": "Replace logo",
    "remove": "Remove logo",
    "uploading": "Uploading the logo",
    "removeTitle": "Remove the company logo?",
    "removeBody": "Documents will print without a logo until you upload one.",
    "toast": {
      "uploaded": "Logo uploaded",
      "replaced": "Logo replaced",
      "removed": "Logo removed"
    }
  },
  "signature": {
    "title": "Authorised signature",
    "body": "Printed over the signature line of posted documents; never on drafts or void ones.",
    "rules": "PNG, JPEG or WebP, up to {{limit}} and {{max}} × {{max}} pixels. Sign in dark ink on white paper and scan it; a transparent PNG prints best.",
    "none": "No signature yet. Posted documents print an empty signature box.",
    "preview": "As printed",
    "upload": "Upload signature",
    "replace": "Replace signature",
    "remove": "Remove signature",
    "uploading": "Uploading the signature",
    "removeTitle": "Remove the authorised signature?",
    "removeBody": "Posted documents will print an empty signature box until you upload one.",
    "toast": {
      "uploaded": "Signature uploaded",
      "replaced": "Signature replaced",
      "removed": "Signature removed"
    }
  },
  "stamp": {
    "title": "Company stamp",
    "body": "Printed in the stamp box of posted documents; never on drafts or void ones.",
    "rules": "PNG, JPEG or WebP, up to {{limit}} and {{max}} × {{max}} pixels. Stamp on white paper, scan it and crop close to the stamp's edge.",
    "none": "No stamp yet. Posted documents print an empty stamp box.",
    "preview": "As printed",
    "upload": "Upload stamp",
    "replace": "Replace stamp",
    "remove": "Remove stamp",
    "uploading": "Uploading the stamp",
    "removeTitle": "Remove the company stamp?",
    "removeBody": "Posted documents will print an empty stamp box until you upload one.",
    "toast": {
      "uploaded": "Stamp uploaded",
      "replaced": "Stamp replaced",
      "removed": "Stamp removed"
    }
  }
}
